// noinspection JSUnfilteredForInLoop

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL

// Make sure the authorization header is set.
if (axios.defaults.headers.common['Authorization'] === undefined) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage['token']
}

/**
 * Login and session calls
 * */

export function logIn (payload) {
  return axios.post(`${API_URL}/login`, payload)
}

export function decodeToken (token) {
  return axios.get(`${API_URL}/token/${token}`)
}

export function fetchSession () {
  return axios.get(`${API_URL}/session`)
}

export function fetchUser (loginId) {
  return axios.get(`${API_URL}/users/${loginId}`)
}

export function fetchUserPhotoThumbnail (loginId) {
  return axios.get(`${API_URL}/users/${loginId}/photo-thumbnail`)
}

export function fetchUserPermissions (loginId) {
  return axios.get(`${API_URL}/users/${loginId}/permissions`)
}

export function fetchUserRoles (loginId) {
  return axios.get(`${API_URL}/users/${loginId}/roles`)
}

export function fetchCurrentPageId (path) {
  return axios.get(`${API_URL}/acl/pages`, {
    params: {
      path: path
    }
  })
}

export function fetchUserNavigation (loginId) {
  return axios.get(`${API_URL}/users/${loginId}/navigation`)
}

/**
* Dashboard calls
* */

export function fetchActionItems () {
  return axios.get(`${API_URL}/dashboard/action-items`)
}

export function fetchSalesPipeline () {
  return axios.get(`${API_URL}/dashboard/sales-pipeline`)
}

export function fetchPastDueAtRisk () {
  return axios.get(`${API_URL}/dashboard/past-due-at-risk`)
}

export function fetchCustomerContacts () {
  return axios.get(`${API_URL}/dashboard/customer-contacts`)
}

export function fetchBillingAndSales () {
  return axios.get(`${API_URL}/dashboard/billing-and-sales`)
}

export function fetchOffToday () {
  return axios.get(`${API_URL}/dashboard/off-today`)
}

export function fetchHotOrders () {
  return axios.get(`${API_URL}/dashboard/hot-orders`)
}

export function fetchPastDueByOffice () {
  return axios.get(`${API_URL}/dashboard/past-due-by-office`)
}

export function fetchDropShips () {
  return axios.get(`${API_URL}/dashboard/dropships`)
}

export function fetchCreditHolds () {
  return axios.get(`${API_URL}/dashboard/credit-holds`)
}

export function fetchQuote () {
  return axios.get(`${API_URL}/dashboard/quote`)
}

export function fetchBackgroundImage () {
  return axios.get(`${API_URL}/dashboard/background-image`)
}

/**
 * Sales Order calls
 * */

export function fetchSalesOrders (params) {
  return axios.get(`${API_URL}/sales-orders/`, {
    params: params
  })
}

export function fetchSalesOrder (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}`)
}

export function fetchSalesOrderAddresses (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}/addresses`)
}

export function fetchSalesOrderLineItems (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}/line-items`)
}

export function fetchSalesOrderStatuses () {
  return axios.get(`${API_URL}/sales-orders/statuses`)
}

export function fetchSalesOrderStatusChanges (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}/status-changes`)
}

export function fetchSalesOrderIssues (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}/issues`)
}

export function fetchSalesOrderPhotos (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}/photos`)
}

export function fetchSalesOrderLockNotes (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}/lock-notes`)
}

export function fetchSalesOrderTracking (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}/tracking`)
}

export function updateSalesOrderStatus (payload) {
  const sono = payload['salesOrderNumber']
  const status = payload['status']
  return axios.patch(`${API_URL}/sales-orders/${sono}`, {'status': status})
}

export function updateSalesOrderNotes (payload) {
  const sono = payload['salesOrderNumber']
  const note = payload['note']
  return axios.patch(`${API_URL}/sales-orders/${sono}`, {'note': note})
}

export function updateSalesOrderHot (payload) {
  const sono = payload['salesOrderNumber']
  const hot = payload['hot']
  return axios.patch(`${API_URL}/sales-orders/${sono}`, {'hot': hot})
}

export function updateSalesOrderSelect (payload) {
  const sono = payload['salesOrderNumber']
  const select = payload['select']
  return axios.patch(`${API_URL}/sales-orders/${sono}`, {'select': select})
}

export function updateSalesOrderLocked (payload) {
  const sono = payload['salesOrderNumber']
  const locked = payload['locked']
  const note = payload['note']
  return axios.patch(`${API_URL}/sales-orders/${sono}`, {'locked': locked, 'lock-note': note})
}

export function fetchRelatedSalesOrderFiles (sono) {
  return axios.get(`${API_URL}/sales-orders/${sono}/files`)
}

export function uploadRelatedSalesOrderFile (payload) {
  const formData = payload['formData']
  const sono = payload['salesOrderNumber']
  const headers = {'Content-Type': 'multipart/form-data'}
  return axios.post(`${API_URL}/sales-orders/${sono}/files`, formData, {headers: headers})
}

/**
 * Client calls.
 * */
export function fetchClient (custno) {
  return axios.get(`${API_URL}/clients/${custno}`)
}

export function fetchAverageDaysBetweenOrders (custno) {
  return axios.get(`${API_URL}/clients/${custno}/days-between-orders`)
}

export function fetchHistoricalMargins (custno) {
  return axios.get(`${API_URL}/clients/${custno}/historical-margins`)
}

export function fetchClientAddresses (params) {
  return axios.get(`${API_URL}/clients/addresses`, {
    params:params
  })
}

/**
 * File calls
 * */

export function downloadFile (fileId) {
  return axios.get(`${API_URL}/files/${fileId}`)
}

/**
 * ACL Calls.
 * */
export function fetchACLResources () {
  return axios.get(`${API_URL}/acl/resources`)
}

export function fetchACLPolicyGroups () {
  return axios.get(`${API_URL}/acl/policy-groups`)
}

export function createACLResource (payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'post',
    url: `${API_URL}/acl/resources`,
    data: form
  })
}

export function createACLPolicyGroup (policyGroupName) {
  const form = new FormData()
  form.append('name', policyGroupName)
  return axios({
    method: 'post',
    url: `${API_URL}/acl/policy-groups`,
    data: form
  })
}

export function createACLPolicyGroupPolicy (policyGroupId, policyId) {
  const form = new FormData()
  form.append('policyGroupId', policyGroupId)
  form.append('policyId', policyId)
  return axios({
    method: 'post',
    url: `${API_URL}/acl/policy-group-policies`,
    data: form
  })
}

export function createACLRole (roleName) {
  const form = new FormData()
  form.append('name', roleName)
  return axios({
    method: 'post',
    url: `${API_URL}/acl/roles`,
    data: form
  })
}

export function createACLSubordinate (payload) {
  const roleId = payload['roleId']
  const subordinateRoleId = payload['subordinateRoleId']
  const form = new FormData()
  form.append('roleId', roleId)
  form.append('subordinateRoleId', subordinateRoleId)
  return axios({
    method: 'post',
    url: `${API_URL}/acl/role-subordinates`,
    data: form
  })
}

export function createACLUser (payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'post',
    url: `${API_URL}/users/`,
    data: form
  })
}

export function createACLUserRole (payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'post',
    url: `${API_URL}/acl/user-roles`,
    data: form
  })
}

export function createACLRolePolicy (payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'post',
    url: `${API_URL}/acl/role-policies`,
    data: form
  })
}

export function createACLHeader (payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'post',
    url: `${API_URL}/acl/header`,
    data: form
  })
}

export function createACLPage (payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'post',
    url: `${API_URL}/acl/pages`,
    data: form
  })
}

export function createACLRolePage (payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'post',
    url: `${API_URL}/acl/role-pages`,
    data: form
  })
}

export function fetchACLPolicies () {
  return axios.get(`${API_URL}/acl/policies`)
}

export function fetchACLPolicyGroupPolicies (policyGroupId) {
  return axios.get(`${API_URL}/acl/policy-group-policies`, {
    params: {
      policyGroupId: policyGroupId
    }
  })
}

export function fetchACLRoles () {
  return axios.get(`${API_URL}/acl/roles`)
}

export function fetchACLRole (roleId) {
  return axios.get(`${API_URL}/acl/roles/${roleId}`)
}

export function fetchACLRoleSubordinates (roleId) {
  return axios.get(`${API_URL}/acl/roles/${roleId}/subordinates`)
}

export function fetchACLUsers () {
  return axios.get(`${API_URL}/users/`)
}

export function fetchACLUser (loginId) {
  return axios.get(`${API_URL}/users/${loginId}`)
}

export function fetchACLUserRoles (loginId) {
  return axios.get(`${API_URL}/acl/user-roles`, {
    params: {
      loginId: loginId
    }
  })
}

export function fetchACLRolePolicies (roleId) {
  return axios.get(`${API_URL}/acl/role-policies`, {
    params: {
      roleId: roleId
    }
  })
}

export function fetchACLPagePermissions (pageId) {
  return axios.get(`${API_URL}/acl/navigation/${pageId}/permissions`)
}

export function fetchACLHeaders () {
  return axios.get(`${API_URL}/acl/header`)
}

export function fetchACLPages () {
  return axios.get(`${API_URL}/acl/pages`)
}

export function fetchACLNavigation () {
  return axios.get(`${API_URL}/acl/navigation`)
}

export function deleteACLResource (resourceId) {
  return axios({
    method: 'delete',
    url: `${API_URL}/acl/resources/${resourceId}`
  })
}

export function deleteACLPolicyGroup (policyGroupId) {
  return axios({
    method: 'delete',
    url: `${API_URL}/acl/policy-groups/${policyGroupId}`
  })
}

export function deleteACLPolicyGroupPolicy (policyGroupPolicyId) {
  return axios.delete(`${API_URL}/acl/policy-group-policies/${policyGroupPolicyId}`)
}

export function deleteACLRole (roleId) {
  return axios.delete(`${API_URL}/acl/roles/${roleId}`)
}

export function deleteACLSubordinate (roleSubordinateId) {
  return axios.delete(`${API_URL}/acl/role-subordinates/${roleSubordinateId}`)
}

export function deleteACLUser (loginId) {
  return axios.delete(`${API_URL}/users/${loginId}`)
}

export function deleteACLUserRole (userRoleId) {
  return axios.delete(`${API_URL}/acl/user-roles/${userRoleId}`)
}

export function deleteACLRolePolicy (rolePolicyId) {
  return axios.delete(`${API_URL}/acl/role-policies/${rolePolicyId}`)
}

export function deleteACLHeader (headerId) {
  return axios.delete(`${API_URL}/acl/header/${headerId}`)
}

export function deleteACLPage (pageId) {
  return axios.delete(`${API_URL}/acl/pages/${pageId}`)
}

export function deleteACLRolePage (rolePageId) {
  return axios.delete(`${API_URL}/acl/role-pages/${rolePageId}`)
}

export function updateACLUser (loginId, payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'patch',
    url: `${API_URL}/users/${loginId}`,
    data: form
  })
}

/**
 * Dashboard Configuration calls.
 * */
export function createDashboardConfiguration (payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'post',
    url: `${API_URL}/dashboard-configuration/`,
    data: form
  })
}

export function deleteDashboardConfiguration (configurationId) {
  return axios.delete(`${API_URL}/dashboard-configuration/${configurationId}`)
}

export function fetchUserDashboardConfiguration (loginId) {
  return axios.get(`${API_URL}/users/${loginId}/dashboard-configuration`)
}

export function updateDashboardConfiguration (configurationId, payload) {
  const form = new FormData()
  for (let key in payload) {
    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      form.append(key, payload[key])
    }
  }
  return axios({
    method: 'patch',
    url: `${API_URL}/dashboard-configuration/${configurationId}`,
    data: form
  })
}

/**
 * Shipping calls
 * */

/**
 * Packaging calls.
 * */
export function createPackaging (sono) {
  const form = new FormData()
  form.append('sono', sono)
  return axios({
    method: 'post',
    url: `${API_URL}/packaging/`,
    data: form
  })
}

export function createPackage (packagingId) {
  const form = new FormData()
  form.append('packagingId', packagingId)
  return axios({
    method: 'post',
    url: `${API_URL}/packaging/packages`,
    data: form
  })
}

export function fetchCompletePackaging (sono) {
  return axios.get(`${API_URL}/packaging/complete/${sono}`)
}

export function fetchPackageContents (packageId) {
  return axios.get(`${API_URL}/packaging/packages/${packageId}/contents`)
}

export function deletePackage (packageId) {
  return axios.delete(`${API_URL}/packaging/packages/${packageId}`)
}

export function deleteContents (contentId) {
  return axios.delete(`${API_URL}/packaging/packages/content/${contentId}`)
}

export function createPackageItem(packageId, item, quantity) {
  const form = new FormData()
  form.append('packageId', packageId)
  form.append('item', item)
  form.append('quantity', quantity)

  return axios({
    method: 'post',
    url: `${API_URL}/packaging/packages/content`,
    data: form
  })
}

export function deletePackageItem(contentId) {
  return axios.delete(`${API_URL}/packaging/packages/content/${contentId}`)
}

export function fetchPackageItemContent(contentId) {
  return axios.get(`${API_URL}/packaging/packages/content/${contentId}`)
}

export function updatePackageItem(contentId, payload) {

  // Create a FormData object.
  const data = new FormData()
  for (let key in payload) {
    if (key !== 'itemFileProcessingId') {
      // noinspection JSUnfilteredForInLoop
      data.append(key, payload[key])
    }
  }

  return axios.patch(`${API_URL}/packaging/packages/content/${contentId}`, data)

}

export function createPackagingPallet (packagingId) {
  const data = new FormData()
  data.append('packagingId', packagingId)
  return axios({
    url: `${API_URL}/packaging/pallets`,
    method: 'post',
    data: data
  })
}

export function fetchPackagingPallets (packagingId) {
  return axios.get(`${API_URL}/packaging/pallets`, {
    params: {
      packagingId: packagingId
    }
  })
}

export function updatePackage (packageId, payload) {

  // Create a form.
  const form = new FormData()
  for (let key in payload) {
    // noinspection JSUnfilteredForInLoop
    form.append(key, payload[key])
  }

  return axios({
    url: `${API_URL}/packaging/packages/${packageId}`,
    method: 'patch',
    data: form
  })

}

/**
 * Item File calls
 * */
export function uploadItemFile(file) {

  // Create a new form
  const form = new FormData()

  // Set the headers.
  const headers = {'Content-Type': 'multipart/form-data'}

  // Add the file to the form.
  form.append('file', file)

  // Upload the file and return the response.
  return axios.post(`${API_URL}/item-files/uploaded-files`, form, {headers: headers})

}

export function createItemFile(payload) {

  // Create a FormData object from payload.
  const data = new FormData()
  for (let key in payload) {
    // noinspection JSUnfilteredForInLoop
    data.append(key, payload[key])
  }

  return axios({
    method: 'post',
    url: `${API_URL}/item-files/`,
    data: data
  })
}

export function fetchUploadedItemFiles () {
  return axios.get(`${API_URL}/item-files/uploaded-files`)
}

export function downloadUploadedItemFile(key) {
  return axios.get(`${API_URL}/item-files/uploaded-files/${key}`)
}

export function updateUploadedItemFile(payload) {

  // Get the item file processing ID.
  const itemFileProcessingId = payload['itemFileProcessingId']

  // Create a FormData object.
  const data = new FormData()
  for (let key in payload) {
    if (key !== 'itemFileProcessingId') {
      // noinspection JSUnfilteredForInLoop
      data.append(key, payload[key])
    }
  }

  // Make the API call.
  return axios.patch(
      `${API_URL}/item-files/${itemFileProcessingId}`,
      data,
      {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
      )

}

/**
 * Product Attribute calls.
 * */
export function fetchAllAttributeNames () {
  return axios.get(`${API_URL}/product-attributes/names/complete`)
}

export function fetchAllAttributeValues () {
  return axios.get(`${API_URL}/product-attributes/values/complete`)
}

export function fetchAttributeValueTypes () {
  return axios.get(`${API_URL}/product-attributes/value-types`)
}

export function fetchAttributeNameTypes (params) {
  return axios.get(`${API_URL}/product-attributes/name-types`, {
    params: params
  })
}

export function fetchAttributeNames (params) {
  return axios.get(`${API_URL}/product-attributes/names`, {
    params: params
  })
}

export function fetchAttributeValues (params) {
  return axios.get(`${API_URL}/product-attributes/values`, {
    params: params
  })
}

export function fetchMasterAttributeName (masterAttributeNameId) {
  return axios.get(`${API_URL}/product-attributes/names/${masterAttributeNameId}`)
}

export function fetchVariantAttributeName (variationAttributeNameId) {
  return axios.get(`${API_URL}/product-attributes/names/variants/${variationAttributeNameId}`)
}

export function fetchMasterAttributeValue (masterAttributeValueId) {
  return axios.get(`${API_URL}/product-attributes/values/${masterAttributeValueId}`)
}

export function fetchVariantAttributeValue (variationAttributeValueId) {
  return axios.get(`${API_URL}/product-attributes/values/variants/${variationAttributeValueId}`)
}

export function createMasterAttributeName (payload) {
  // Create a FormData object.
  const data = new FormData()
  for (let key in payload) {
    // noinspection JSUnfilteredForInLoop
    data.append(key, payload[key])
  }

  return axios.post(`${API_URL}/product-attributes/names`, data)

}

export function createVariantAttributeName (payload) {

  // Create a FormData object.
  const data = new FormData()
  for (let key in payload) {
    // noinspection JSUnfilteredForInLoop
    data.append(key, payload[key])
  }

  return axios.post(`${API_URL}/product-attributes/names/variants`, data)

}

export function createMasterAttributeValue (payload) {

  // Create a FormData object.
  const data = new FormData()
  for (let key in payload) {
    // noinspection JSUnfilteredForInLoop
    data.append(key, payload[key])
  }

  return axios.post(`${API_URL}/product-attributes/values`, data)

}

export function createVariantAttributeValue (payload) {

  // Create a FormData object.
  const data = new FormData()
  for (let key in payload) {
    // noinspection JSUnfilteredForInLoop
    data.append(key, payload[key])
  }

  return axios.post(`${API_URL}/product-attributes/values/variants`, data)

}

export function updateMasterAttributeName (masterAttributeNameId, payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.patch(`${API_URL}/product-attributes/names/${masterAttributeNameId}`, data)
}
export function updateVariantAttributeName (variationAttributeNameId, payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.patch(`${API_URL}/product-attributes/names/variants/${variationAttributeNameId}`, data)
}
export function updateMasterAttributeValue (masterAttributeValueId, payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.patch(`${API_URL}/product-attributes/values/${masterAttributeValueId}`, data)
}
export function updateVariantAttributeValue (variationAttributeValueId, payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.patch(`${API_URL}/product-attributes/values/variants/${variationAttributeValueId}`, data)
}

export function deleteMasterAttributeName (masterAttributeNameId) {
  return axios.delete(`${API_URL}/product-attributes/names/${masterAttributeNameId}`)
}

export function deleteVariantAttributeName (variationAttributeNameId) {
  return axios.delete(`${API_URL}/product-attributes/names/variants/${variationAttributeNameId}`)
}

export function deleteMasterAttributeValue (masterAttributeValueId) {
  return axios.delete(`${API_URL}/product-attributes/values/${masterAttributeValueId}`)
}

export function deleteVariantAttributeValue (variationAttributeValueId) {
  return axios.delete(`${API_URL}/product-attributes/values/variants/${variationAttributeValueId}`)
}

export function fetchAttributeErrors (params) {
  return axios.get(`${API_URL}/product-attributes/errors`, {
    params: params
  })
}

/**
 * Item calls.
 * */
export function fetchItem (item) {
  return axios.get(`${API_URL}/items/${item}`)
}

export function fetchItemCategories (params) {
  return axios.get(`${API_URL}/items/categories`, {
    params: params
  })
}

export function fetchItemAvailability (item) {
  return axios.get(`${API_URL}/items/${item}/availability`)
}

export function fetchItemOpenSalesOrders (item) {
  return axios.get(`${API_URL}/items/${item}/open-sales-orders`)
}

export function fetchItemOpenOpportunities (item) {
  return axios.get(`${API_URL}/items/${item}/open-opportunities`)
}

export function fetchItemLocations (item) {
  return axios.get(`${API_URL}/items/${item}/open-opportunities`)
}

/**
 * Product calls.
 * */
export function checkProductExists (payload) {
  const item = payload.item
  delete payload.item
  return axios.get(`${API_URL}/products/${item}/exists`, {
    params: payload
  })
}

export function createProduct (payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.post(`${API_URL}/products/`, data)
}

export function createProductAttribute (payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.post(`${API_URL}/products/attributes`, data)
}

export function fetchProducts (payload) {
  return axios.get(`${API_URL}/products`, {
    params: payload
  })
}

export function fetchProduct (productId) {
  return axios.get(`${API_URL}/products/${productId}`)
}

export function fetchProductCount (payload) {
  return axios.get(`${API_URL}/products/count`, {
    params: payload
  })
}

export function fetchProductAttributes (productId) {
  return axios.get(`${API_URL}/products/${productId}/attributes`)
}

export function updateProduct (payload) {
  const productId = payload.productId
  delete payload.productId

  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }

  return axios.patch(`${API_URL}/products/${productId}`, data)

}

export function updateProductAttribute (payload) {

  const productAttributeId = payload.productAttributeId
  delete payload.productAttributeId

  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }

  return axios.patch(`${API_URL}/products/attributes/${productAttributeId}`, data)

}

export function deleteProduct (productId) {
  return axios.delete(`${API_URL}/products/${productId}`)
}

/**
 * Item-Category Template calls.
 * */
export function createItemCategoryTemplate (payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.post(`${API_URL}/product-attributes/templates`, data)
}

export function createItemCategoryTemplateDefinition (payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.post(`${API_URL}/product-attributes/templates/definition`, data)
}

export function createAttributeOption (payload) {
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.post(`${API_URL}/product-attributes/options`, data)
}

export function createAttributeOptionChoice(payload) {
  delete payload.optionChoiceId
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.post(`${API_URL}/product-attributes/options/choices`, data)
}

export function fetchCompleteItemCategoryTemplates (payload) {
  return axios.get(`${API_URL}/product-attributes/templates/complete`, {
    params: payload
  })
}

export function fetchItemCategoryTemplates (payload) {
  return axios.get(`${API_URL}/product-attributes/templates`, {
    params: payload
  })
}

export function fetchItemCategoryTemplate (categoryTemplateId) {
  return axios.get(`${API_URL}/product-attributes/templates/${categoryTemplateId}`)
}

export function fetchAllAttributeOptions (payload) {
  return axios.get(`${API_URL}/product-attributes/options/complete`, {
    params: payload
  })
}

export function fetchAttributeOptionChoices(payload){
  return axios.get(`${API_URL}/product-attributes/options/choices`, {
    params: payload
  })
}

export function updateItemCategoryTemplate (payload) {

  // Get the category template ID.
  const categoryTemplateId = payload['categoryTemplateId']
  delete payload['categoryTemplateId']

  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }

  return axios.patch(`${API_URL}/product-attributes/templates/${categoryTemplateId}`, data)

}

export function updateItemCategoryTemplateDefinition (payload) {
  // Get the category template ID.
  const categoryTemplateDefinitionId = payload['categoryTemplateDefinitionId']
  delete payload['categoryTemplateDefinitionId']

  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }

  return axios.patch(`${API_URL}/product-attributes/templates/definition/${categoryTemplateDefinitionId}`, data)

}

export function updateAttributeOption (payload) {
  const optionId = payload.optionId
  delete payload.optionId
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.patch(`${API_URL}/product-attributes/options/${optionId}`, data)
}

export function updateAttributeOptionChoice (payload) {
  const optionsChoiceId = payload.optionsChoiceId
  delete payload.optionsChoiceId
  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }
  return axios.patch(`${API_URL}/product-attributes/options/choices/${optionsChoiceId}`, data)
}

export function deleteItemCategoryTemplate (categoryTemplateId) {
  return axios.delete(`${API_URL}/product-attributes/templates/${categoryTemplateId}`)
}

export function deleteItemCategoryTemplateDefinition (categoryTemplateDefinitionId) {
  return axios.delete(`${API_URL}/product-attributes/templates/definition/${categoryTemplateDefinitionId}`)
}

export function deleteAttributeOption (optionId) {
  return axios.delete(`${API_URL}/product-attributes/options/${optionId}`)
}

export function deleteAttributeOptionChoice (optionsChoiceId) {
  return axios.delete(`${API_URL}/product-attributes/options/choices/${optionsChoiceId}`)
}

/**
 * Action Item Type calls
 * */
export function createActionItemType (payload) {

  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }

  return axios.post(`${API_URL}/action-items/types`, data)

}

export function fetchActionItemTypes (params) {
  return axios.get(`${API_URL}/action-items/types`, {
    params: params
  })
}

export function updateActionItemType (payload) {

  const taskTypeId = payload.taskTypeId
  delete payload.taskTypeId

  const data = new FormData()
  for (let key in payload) {
    data.append(key, payload[key])
  }

  return axios.patch(`${API_URL}/action-items/types/${taskTypeId}`, data)

}

export function deleteActionItemType (taskTypeId) {
  return axios.delete(`${API_URL}/action-items/types/${taskTypeId}`)
}

/**
 * Magento Category Calls
 * */
export function fetchMagentoCategories (params) {
  return axios.get(`${API_URL}/magento/categories`, {
    params: params
  })
}

export function bulkCategorizeProducts (payload) {
  return axios.post(`${API_URL}/magento/categories/bulk-products`, payload)
}

export function fetchBulkMagentoCategoryJobs (params) {
  return axios.get(`${API_URL}/magento/categories/bulk-products/jobs`, {
    params: params
  })
}

export function fetchBulkMagentoJob (bulkUuid) {
  return axios.get(`${API_URL}/magento/bulk-jobs/${bulkUuid}`)
}

export function deleteBulkMagentoCategoryJob (jobId) {
  return axios.delete(`${API_URL}/magento/categories/bulk-products/jobs/${jobId}`)
}

/**
 * Printers
 * */
export function fetchPrinters (params) {
  return axios.get(`${API_URL}/printers`, {
    params: params
  })
}

/**
 * Warehouses
 * */
export function fetchWarehouses (params) {
  return axios.get(`${API_URL}/warehouses`, {
    params: params
  })
}

/**
 * Shipping Packages
 * */
export function fetchShippingPackages (params) {
  return axios.get(`${API_URL}/shipping-packages`, {
    params: params
  })
}

/**
 * ShipEngine
 * */
export function createShippingQuotes (payload) {

  // const data = new FormData()
  // for (let key in payload) {
  //   data.append(key, payload[key])
  // }

  return axios.post(`${API_URL}/shipping/rates`, payload, {
    headers: {'Content-Type': 'application/json'}
  })

}

export function purchaseLabelByRateId (rateId) {
  return axios.post(`${API_URL}/shipping/rates/${rateId}`, {
    headers: {'Content-Type': 'application/json'}
  })
}

export function printLabelByZPL (payload) {
  return axios.post(`${API_URL}/shipping/labels/printing/zpl`, payload, {
    headers: {'Content-Type': 'application/json'}
  })
}

/**
 * Carrier Codes
 * */
export function fetchCarrierCodes (params) {
  return axios.get(`${API_URL}/carrier-codes`, {
    params: params
  })
}

/**
 * Internal Magento Orders
 * */
export function updateInternalMagentoOrder (payload) {
  const data = new FormData()
  for (let key in payload) {
    // noinspection JSUnfilteredForInLoop
    data.append(key, payload[key])
  }
  const internal_magento_order_id = payload.magentoIdInternal
  delete payload.magentoIdInternal
  return axios.post(`${API_URL}/magento/internal-orders/${internal_magento_order_id}}`, data)
}